import * as _ from "lodash";
import { TableCellRenderer } from "react-table";

import { CustomTableColumn } from "src/library/components/Tables/Table";
import * as globalTableColumns from "src/core/shared/components/TableGlobalColumns";
import { IOrderExportSetting } from "src/modules/order-export/api/order-export.api";

export const orderExportTableColumns = (ActionButton: TableCellRenderer, exportSettings: IOrderExportSetting[] | null): CustomTableColumn[] => [
  globalTableColumns.standardText({
    Header: "Export type",
    accessor: "orderExportSettingId",
    sortable: false,
    filterable: false,
    Cell: row => {
      const setting = _.find(exportSettings, es => es.id === row.value);

      if (setting) {
        return setting.name;
      }

      return "";
    }
  }),
  globalTableColumns.date({
    header: "Exported at",
    accessor: "exportedAt",
    template: "datetime"
  }),
  globalTableColumns.standardText({
    Header: "Total lines",
    accessor: "totalCount"
  }),
  globalTableColumns.actions({ cell: ActionButton })
];
